import type { spec } from '@galacean/effects';

/**
 * Model 插件元素类型
 */
export const VFX_ITEM_TYPE_3D = 'PluginModel' as spec.ItemType;
